export default __webpack_public_path__ + "static/media/gift-aid.3b1b9e67.svg";